import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LineReveal, FadeUp } from "../components/RevealText";
import { PROJECTS } from "./Projects";

export default function ProjectDetail() {
  const { slug } = useParams();
  const project = PROJECTS.find((p) => p.slug === slug) || PROJECTS[0];

  return (
    <main data-testid="project-detail-page" className="bg-black text-white pt-24">
      <section className="border-b border-white/10 px-4 md:px-6 py-6">
        <Link
          to="/projects"
          data-testid="back-to-projects"
          className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-white/60 hover:text-white transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          All projects
        </Link>
      </section>

      <section className="border-b border-white/10 px-4 md:px-6 py-8 md:py-12">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/50 mb-4">
          {project.location}
        </p>
        <h1 className="font-display font-bold text-5xl md:text-7xl leading-[0.9] uppercase">
          <LineReveal delay={0.1}>{project.name}</LineReveal>
        </h1>
      </section>

      {/* Cover Image */}
      <section
        data-testid="project-gallery"
        className="relative border-b border-white/10 h-[55vh] md:h-[70vh] overflow-hidden bg-neutral-950"
      >
        <img
          src={project.cover}
          alt={project.name}
          data-testid="project-cover-image"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </section>

      {/* Summary */}
      <section className="border-b border-white/10 px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-12 gap-6">
          <FadeUp className="col-span-12 md:col-span-8 md:col-start-3">
            <p className="text-white/75 text-lg md:text-xl leading-relaxed">
              {project.summary}
            </p>
          </FadeUp>
        </div>
      </section>
    </main>
  );
}
